import i18n from "@/plugins/i18n";
import moment from "moment";

/**
 * returns DateTime in Seconds otherwise null
 * @param  {String} date
 * @param  {Integer} hours set/add hours in date
 */
function parseDateTime(date, hours) {
  return new Date(date).setHours(hours, 0, 0, 0) / 1000 || null;
}

function parseLocaleDateTime(date) {
  return new Date(date).toLocaleString(i18n.locale, {
    hour12: false
  });
}

function parseSeverity(severity) {
  switch (severity) {
    case 1:
      return i18n.t("modules.logs.severity.normal");
    case 2:
      return i18n.t("modules.logs.severity.minor");
    case 3:
      return i18n.t("modules.logs.severity.major");
    case 4:
      return i18n.t("modules.logs.severity.critical");
    default:
      return "";
  }
}

function parseColor(severity) {
  switch (severity) {
    case 1:
      return "logs__severity_normal";
    case 2:
      return "logs__severity_minor";
    case 3:
      return "logs__severity_major";
    case 4:
      return "logs__severity_critical";
    default:
      return "logs__severity_none";
  }
}

function parseLogDatetime(date) {
  const datetime = moment(date).format("DD/MM/YYYY, HH:mm:ss");

  return datetime;
}

export default {
  parseDateTime,
  parseLocaleDateTime,
  parseSeverity,
  parseColor,
  parseLogDatetime
};
